import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { ConfirmDialog } from 'src/components/shared/dialog/ConfirmDialog';
import { useThrottle } from 'src/lib/hooks/useThrottle';
import { getQueryParam } from 'src/lib/utils';

interface ReportSucceededDialogProps {
  basePath: string;
}

export const ReportSucceededDialog: React.FC<ReportSucceededDialogProps> = ({ basePath }) => {
  const { t } = useTranslation(['translation', 'resort']);
  const history = useHistory();
  const location = useLocation();
  const goBack = useThrottle(() => history.goBack(), 1000); // 連打対策
  const isFollowing = getQueryParam(location.search, 'is-following') === 'true';
  const isUnlocked = getQueryParam(location.search, 'is-unlocked') === 'true';
  const title = t('dialog_report_success');
  const description = isFollowing ? t('resort:report_resort_complete') : t('report_spam_complete');

  const handleConfirmClick = useCallback(() => {
    if (isUnlocked) {
      history.replace(`${basePath}/history-delete`);
    } else {
      goBack();
    }
  }, [isUnlocked, history, goBack, basePath]);

  return (
    <ConfirmDialog
      title={title}
      description={description}
      confirmLabel={t('dialog_button_ok')}
      onConfirmClick={handleConfirmClick}
    />
  );
};
